import {
  Component,
  OnInit,
  Input
} from '@angular/core';
import {
  StationAvailabilities
} from 'src/app/models/api_models/station';
import {
  StationService
} from 'src/app/api/station.service';
import {
  Station
} from 'src/app/models/api_models/station';
import {
  BookResult
} from 'src/app/models/api_models/book';

@Component({
  selector: 'app-station-availabilities-graph',
  templateUrl: './station-availabilities-graph.component.html',
  styleUrls: ['./station-availabilities-graph.component.scss']
})
export class StationAvailabilitiesGraphComponent implements OnInit {

  private _dayCount: Date[] = [];
  get dayCount() : Date[] {return this._dayCount;}
  set dayCount(dayCount : Date[]) {this._dayCount = dayCount};

  private _hourCount: string[] = [];
  get hourCount() : string[] {return this._hourCount;}
  set hourCount(hourCount : string[]) {this._hourCount = hourCount;}

  private _canReserved = true;
  get canReserved() : boolean {return this._canReserved;}
  set canReserved(canReserved : boolean) {this._canReserved = canReserved;}

  private _availabilities: string[] = [];
  get availabilities() : string[] {return this._availabilities;}
  set availabilities(availabilities : string[] ) {this._availabilities = availabilities;}

  private _stationAvailabilities : StationAvailabilities = null;
  get stationAvailabilities() : StationAvailabilities {
    return this._stationAvailabilities;
  }
  
  set stationAvailabilities(stationAvailabilities : StationAvailabilities) {
    this._stationAvailabilities = stationAvailabilities;
    if (this._stationAvailabilities !== null) {
      this._availabilities =  this.convertAvalabilites();
    }
  }

  private _station: Station = null;
  get station(): Station {
    return this._station;
  }

  @Input()
  set station(station: Station) {
    this._station = station;
    this.updateStationAvailabilities();
  }

  private _stationId: number = null;
  get stationId(): number {
    return this._stationId;
  }

  @Input()
  set stationId(stationId: number) {
    this._stationId = stationId;
    if (this._stationId !== null) {
      this.stationService.getStationDetailFromId(this._stationId).subscribe(
        response => {
          this._station = this.stationService.convertStationDetailToStation(response);
          this.updateStationAvailabilities();
        }
      )
    }
  }


  private _start: string = null;
  get start(): string {
    return this._start;
  }

  @Input()
  set start(start: string) {
    this._start = start;
    this.updateStationAvailabilities();
  }

  private _end: string = null;
  get end(): string {
    return this._end;
  }

  @Input()
  set end(end: string) {
    this._end = end;
    this.updateStationAvailabilities();
  }

  private _userBook: BookResult = null;
  get userBook(): BookResult {
    return this._userBook;
  }

  @Input()
  set userBook(userBook: BookResult) {
    this._userBook = userBook;
    // console.log(userBook);
    if (this._stationId == null && this._userBook != null) {


      let startDate = new Date(this._userBook.startdate);
      startDate.setHours(0, 0, 0, 0);
      let day_start = startDate.getDay();
      this._dayCount.push(new Date(startDate));
      let endDate = new Date(this._userBook.enddate);
      endDate.setHours(23, 59, 0, 0);

      this.end = endDate.toISOString();

      this.start = startDate.toISOString();
      this.stationId = this._userBook.station_id;


    }
  }

  updateStationAvailabilities() {

    if (this._station != null && this._start != null && this._end != null) {
      console.log("bonjourrrrr")
      this.stationService.getStationAvailabilities(this._station, this._start, this._end, this._start, this._end, false).subscribe(
        response => {
          if (response.length > 0) {
            this.stationAvailabilities = response[0];
            // console.log(response);
            
          }
        }
      );
    }
  }


  convertAvalabilites() {
    let tab = [];
    let bookStartDate = new Date(this._userBook.startdate);
    bookStartDate.setTime(bookStartDate.getTime() - 1000 * 60 * 30 - (1000 * 60 * 60 * 2) );
    let bookEndDate = new Date(this._userBook.enddate);
    bookEndDate.setTime(bookEndDate.getTime() + 1000 * 60 * 30 - (1000 * 60 * 60 * 2));

    let bookStartDateReal = new Date(this._userBook.startdate);
    let bookEndDateReal = new Date(this._userBook.enddate);
    bookStartDateReal.setTime(bookStartDateReal.getTime()  - (1000 * 60 * 60 * 2));
    bookEndDateReal.setTime(bookEndDateReal.getTime()  - (1000 * 60 * 60 * 2));
    let startDate = new Date(bookStartDate);

    startDate.setHours(0, 0, 0, 0);
    let day_start = startDate.getDay();
    //this._dayCount.push(new Date(startDate));
    let endDate = new Date(bookEndDate);
    endDate.setHours(21, 0, 0, 0);
    let isWanted = false;
    while (startDate < endDate) {
      isWanted = false;
      let strClass = "  ";
      if (startDate.getMinutes() == 0) {
        if (startDate.getHours() % 2 == 0) {
          if (startDate.getHours() < 10) {
            this._hourCount.push("0" + startDate.getHours() + "h");
          } else {
            this._hourCount.push(startDate.getHours() + "h");
          }
        } else {
          this._hourCount.push("    ");
        }
      }

      if (day_start != startDate.getDay()) {
        day_start = startDate.getDay();
        this._dayCount.push(new Date(startDate));
      }

      if (startDate.getTime() == bookStartDate.getTime()) {
        strClass += " start ";
      }
      if (startDate.getTime() >= bookStartDate.getTime() && (startDate.getTime() + (1000 * 60 * 30)) <= bookEndDate.getTime()) {
        strClass += "  user-book ";
        isWanted = true;
      }
      if ((startDate.getTime() + (1000 * 60 * 30)) == bookEndDate.getTime()) {
        strClass += "end";
      }

      if (startDate.getTime() == bookStartDateReal.getTime()) {
        strClass += " start ";
      }
      if (startDate.getTime() >= bookStartDateReal.getTime() && (startDate.getTime() + (1000 * 60 * 30)) <= bookEndDateReal.getTime()) {
        strClass += " wanted ";
        isWanted = true;
      }
      if ((startDate.getTime() + (1000 * 60 * 30)) == bookEndDateReal.getTime()) {
        strClass += "end";
      }
      

      let isStart = false;
      let isEnd = false;
      let isLock = true;
      this._stationAvailabilities.availabilities.forEach(a => {

        let dStart = new Date(a.startdate.replace("Z", ""));
        let dEnd = new Date(a.enddate.replace("Z", ""));
        // if (dEnd.getMinutes() == 59) {
        //   dEnd.setTime(dEnd.getTime() + 1000 * 60 );
        // }

        if (startDate.getTime() == (dStart.getTime() - (1000 * 60 * 30))) {
          strClass += " end ";
          if (isWanted) {
            this._canReserved = false;
          }
          strClass += " reserved ";


        }
        if (startDate.getTime() >= (dStart.getTime() - (1000 * 60 * 30)) && startDate.getTime() <= dEnd.getTime()) {
          isLock = false;
        }
        if (startDate.getTime() == dEnd.getTime()) {
          strClass += " start ";
          if (isWanted) {
            this._canReserved = false;
          }

          strClass += " reserved ";
        }
      });
      if (isLock) {
        if (isWanted) {
          this._canReserved = false;
        }

        strClass += " reserved ";
      }

      tab.push(strClass);
      startDate.setTime(startDate.getTime() + 1000 * 60 * 30);
    }
    return tab;
  }


  constructor(private stationService: StationService) {}

  ngOnInit() {

  }

}
